import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageGroup from 'components/ImageGroup'
// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'
import s from './Polaroids.module.css'

// TODO: Add alt to images.
function Polaroids({ images = [] }) {
  if (images?.length < 1) return null

  const rows = []
  images.forEach((img) => {
    if (
      rows.length === 0 ||
      parseInt(img.orientation, 10) === 4 ||
      parseInt(rows[rows.length - 1][0].orientation, 10) === 4 ||
      rows[rows.length - 1].length === 4
    )
      rows.push([img])
    else rows[rows.length - 1].push(img)
  })

  return rows.map((row) => (
    <ImageGroup key={row[0].sourceUrl} className={s.row}>
      {(handleLoad, indexToResize, ratio) =>
        row.map((image, index) => (
          <div
            key={image.sourceUrl}
            className={classNames(s.imageWrapper, {
              [s.imageWrapperLandscape]: parseInt(image.orientation, 10) === 4,
            })}
          >
            {index === indexToResize && (
              <span
                className={s.imageRatio}
                style={{ paddingTop: `${ratio * 100}%` }}
              />
            )}
            <img
              src={image.sourceUrl}
              className={classNames(s.image, {
                [s.imageResized]: index === indexToResize,
              })}
              alt=""
              loading="lazy"
            />
            {/* <CloudinarySolarnetImage
              className={classNames(s.image, {
                [s.imageResized]: index === indexToResize,
              })}
              image={[
                { url: image.sourceUrl, params: 'w_657,c_fill,f_auto' },
                { url: image.sourceUrl, params: 'w_212,c_fill,f_auto' },
              ]}
              // onLoad={(w, h) => handleLoad(index, w, h)}
            /> */}
          </div>
        ))
      }
    </ImageGroup>
  ))
}

Polaroids.propTypes = {
  images: PropTypes.array,
}

export default Polaroids
